import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)

// axios
import axios from "./axios.js"
Vue.prototype.$http = axios

// Theme Configurations
import '../themeConfig.js'


// ACL
import acl from '@/configs/acl.config.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

// VeeValidate
//import th from 'vee-validate/dist/locale/th';
import VeeValidate /*, { Validator }*/ from 'vee-validate';
Vue.use(VeeValidate);
//Validator.localize('th', th);

Vue.config.productionTip = false

import firebase from 'firebase/app'
import 'firebase/auth'
const configOptions = {
  apiKey: "AIzaSyCIhQBoG-RrooixdDBKSCKicsu0ajvfq5A",
  authDomain: "lottery-7f260.firebaseapp.com",
  databaseURL: "https://lottery-7f260.firebaseio.com",
  projectId: "lottery-7f260",
  storageBucket: "lottery-7f260.appspot.com",
  messagingSenderId: "362560795339",
  appId: "1:362560795339:web:c51e67c6c6c1e69786a14e",
  measurementId: "G-YVJXJHK3VY"
};
firebase.initializeApp(configOptions)

import moment from "@/moment"
Vue.prototype.$moment = moment

new Vue({
  router,
  store,
  acl,
  render: h => h(App)
}).$mount('#app')
